import React, { useState, useEffect } from 'react';
import { Row, Col, InputNumber, Form, Button, Modal, Input, Select, Icon, Alert } from 'antd';
import styles from './subscriptionAddOnPricingTable.module.css';
import { billingFunctions } from 'utils/constants';

const SubscriptionAddOnPricingTable = ({
  form,
  productData,
  selectedPricingTable,
  currentSubscriptionProducts,
  selectedSubscriptionAddOnProductsTable
}) => {
  const { getFieldDecorator } = form;

  const [row, setRow] = useState([0]); // Initialize with one product row
  const [column, setColumn] = useState([0]);
  const [columnCount, setColumnCount] = useState(3);
  const [showEmptyBox, setEmptyBox] = useState(true);
  const [counter, setCounter] = useState(1);

  const [packageNames, setPackageNames] = useState([]); // ✅ Add state to track package names

  const [subAddOnSelectedProducts, setSubAddonSelectedProducts] = useState([]);

  // Track previous subscription products to detect column removals and remap values
  const [prevSubscriptionProducts, setPrevSubscriptionProducts] = useState([]);

  // Use fixed width for columns instead of Ant Design's 24-column grid
  // This allows unlimited columns with horizontal scrolling
  // Calculate dynamic column width to fill the container
  const minColWidth = 180; // Minimum width in pixels for each column
  const totalColumns = column.length + 1; // +1 for the first column (Add-Ons/Package header)
  const colWidth = totalColumns > 0 ? `calc((100% - 32px) / ${totalColumns})` : minColWidth;

  const { setFieldsValue, resetFields, getFieldValue } = form;

  const findProductName = productId => {
    const product = productData.find(p => p._id === productId);
    return product ? product.name : '';
  };

  useEffect(() => {
    // console.log(selectedPricingTable)
    if (selectedPricingTable) {
      const pricingCriteriaKeys = Object.keys(selectedPricingTable.pricingCriteria);
      const subscriptionAddOnProducts = selectedPricingTable.subscriptionAddOnProducts || [];

      setRow(subscriptionAddOnProducts.map((_, index) => index));
      setColumn(pricingCriteriaKeys.map((_, index) => index));
      setColumnCount(pricingCriteriaKeys.length + 1 >= 3 ? 4 : 3); // +1 is because, need to add back the first header column
      setCounter(subscriptionAddOnProducts.length);
      setEmptyBox(pricingCriteriaKeys.length <= 2); // +1 is because need to add back the first header column
      const initialValues = {
        subscriptionAddOnProduct: subscriptionAddOnProducts.map((p, index) => ({
          //need to do it like this coz labelInValue
          [`sub-add-on-product[${index}][0]`]: { key: p.product, label: findProductName(p.product) }
        }))
      };

      // Flatten the initialValues object for setFieldsValue
      const flattenedInitialValues = Object.assign({}, ...initialValues.subscriptionAddOnProduct);

      setSubAddonSelectedProducts(
        subscriptionAddOnProducts.map((p, index) => ({
          key: p.product,
          label: findProductName(p.product),
          fieldIndex: index
        }))
      );
      setTimeout(() => {
        setFieldsValue(flattenedInitialValues);
      }, 0);
    } else {
      resetFields();
      setRow([0]);
      setColumn([0]);
      setColumnCount(3);
      setCounter(1);
      setEmptyBox(true);
      setSubAddonSelectedProducts([]);
      setPrevSubscriptionProducts([]);
    }
  }, [selectedPricingTable]);

  // Initialize form data from selectedSubscriptionAddOnProductsTable (when editing existing pricing model)
  useEffect(() => {
    console.log(productData, 1);
    console.log(currentSubscriptionProducts, 2);
    if (!selectedSubscriptionAddOnProductsTable || selectedSubscriptionAddOnProductsTable.length === 0 || !productData || productData.length === 0) {
      return;
    }

    // Set up rows based on the number of subscription add-on products
    const rowIndices = selectedSubscriptionAddOnProductsTable.map((_, index) => index);
    setRow(rowIndices);
    setCounter(selectedSubscriptionAddOnProductsTable.length);

    // Prepare initial values for form fields
    const initialValues = {};
    const selectedProducts = [];

    selectedSubscriptionAddOnProductsTable.forEach((addOnProduct, rowIndex) => {
      // Set the subscription add-on product selection
      const productName = findProductName(addOnProduct.subscriptionAddOnProduct);
      initialValues[`sub-add-on-product[${rowIndex}][0]`] = {
        key: addOnProduct.subscriptionAddOnProduct,
        label: productName
      };

      selectedProducts.push({
        key: addOnProduct.subscriptionAddOnProduct,
        label: productName,
        fieldIndex: rowIndex
      });

      // Set the listing prices for each subscription product (column)
      if (addOnProduct.subscriptionProducts && currentSubscriptionProducts) {
        addOnProduct.subscriptionProducts.forEach(subProduct => {
          // Find the column index based on the subscriptionProduct key
          const colIndex = currentSubscriptionProducts.findIndex(p => p && p.key === subProduct.subscriptionProduct);
          if (colIndex !== -1) {
            initialValues[`listingPrice[${rowIndex}][${colIndex}]`] = subProduct.listingPrice;
          }
        });
      }
    });

    setSubAddonSelectedProducts(selectedProducts);

    setTimeout(() => {
      setFieldsValue(initialValues);
    }, 100);
  }, [selectedSubscriptionAddOnProductsTable, productData, currentSubscriptionProducts]);

  useEffect(() => {
    if (!currentSubscriptionProducts) {
      setPackageNames([]);
      setColumn([]);
      setColumnCount(1);
      setEmptyBox(false);
      setPrevSubscriptionProducts([]);
      return;
    }
    console.log(currentSubscriptionProducts, 'currentSubscriptionProducts');

    const validProducts = currentSubscriptionProducts.filter(p => p && p.key);
    const validColumnCount = validProducts.length;

    console.log(validColumnCount, 13);

    // Remap form values when columns change (e.g., middle column removed)
    if (prevSubscriptionProducts.length > 0 && validProducts.length < prevSubscriptionProducts.length) {
      // A column was removed - need to remap values
      const newValues = {};

      validProducts.forEach((product, newIndex) => {
        // Find the old index of this product
        const oldIndex = prevSubscriptionProducts.findIndex(p => p && p.key === product.key);

        if (oldIndex !== -1 && oldIndex !== newIndex) {
          // This product moved from oldIndex to newIndex, remap its values
          row.forEach(productRowIndex => {
            const oldFieldName = `listingPrice[${productRowIndex}][${oldIndex}]`;
            const newFieldName = `listingPrice[${productRowIndex}][${newIndex}]`;
            const oldValue = getFieldValue(oldFieldName);
            if (oldValue !== undefined) {
              newValues[newFieldName] = oldValue;
            }
          });
        }
      });

      // Apply the remapped values
      if (Object.keys(newValues).length > 0) {
        setTimeout(() => {
          setFieldsValue(newValues);
        }, 0);
      }
    }

    // Update previous products for next comparison
    setPrevSubscriptionProducts(validProducts);

    if (validColumnCount > 0) {
      setColumn(validProducts.map((_, index) => index));
      // Dynamic column count: 1 (first column) + number of packages
      setColumnCount(validColumnCount + 1);
      setEmptyBox(false); // No empty box needed with scrolling

      const names = validProducts.map(p => {
        const product = productData.find(prod => prod._id === p.key);
        return product ? product.name : 'Unknown Product';
      });
      setPackageNames(names);
    } else {
      setColumn([]);
      setColumnCount(1);
      setEmptyBox(false);
      setPackageNames([]);
    }
  }, [currentSubscriptionProducts, productData]);

  const addProduct = () => {
    setRow([...row, counter]); // Add a new product row
    setCounter(counter + 1); // Increment counter after adding the row
  };

  const pricing = (row, col, disabled) => {
    return (
      <>
        <Input.Group compact>
          <Row gutter={16} style={{ paddingTop: '2px', width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Col span={12}>
              <Form.Item key={`listingPrice[${col}][${row}]`} style={{ width: '100%', textAlign: 'center', marginBottom: '0px' }}>
                {getFieldDecorator(`listingPrice[${col}][${row}]`, {
                  rules: [
                    { required: true, message: 'Please input price per listing' },
                    { pattern: /^(?:\d*\.\d{1,2}|\d+)$/, message: 'Please enter a valid price with up to 2 decimal places' }
                  ]
                })(
                  <Input
                    placeholder="0.00"
                    style={{ width: '100%', textAlign: 'center' }} // ✅ Added textAlign: 'center'
                    min={0}
                    step={0.01}
                    precision={2}
                    addonAfter="/listing"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Input.Group>
      </>
    );
  };

  const handleProductSelection = (value, productIndex) => {
    //keep track of index and also value
    form.setFieldsValue({
      [`sub-add-on-product[${productIndex}][0]`]: value
    });

    setSubAddonSelectedProducts(prevSelected => {
      // Remove the previously selected product for this index, if any
      //if productIndex matches then discard the array in that specific index, to make way for new value
      const filteredSelected = prevSelected.filter(item => item.fieldIndex !== productIndex);

      // Add the new selection with its field index
      if (value) {
        // Resolve the newly selected product and its matched billingFunction value
        const selectedProduct = productData.find(p => p._id === value.key);
        const selectedProductName = selectedProduct ? selectedProduct.name : null;

        let addOnFunctionValue = null;
        if (selectedProductName) {
          const normalizedProductName = selectedProductName.toLowerCase().replace(/\s+/g, '');
          const matched = billingFunctions.find(bf => normalizedProductName.includes(bf.label.toLowerCase().replace(/\s+/g, '')));
          addOnFunctionValue = matched ? matched.value : null;
        }

        // Clear pricing values for columns that are now disabled for this product
        if (addOnFunctionValue && currentSubscriptionProducts) {
          const fieldsToClear = {};
          column.forEach((_, colIndex) => {
            const subscriptionProduct = currentSubscriptionProducts[colIndex];
            if (!subscriptionProduct || !subscriptionProduct.key) return;
            const packageProduct = productData.find(p => p._id === subscriptionProduct.key);
            if (!packageProduct || !packageProduct.functions) return;
            const isDisabled = !packageProduct.functions.includes(addOnFunctionValue);
            if (isDisabled) {
              fieldsToClear[`listingPrice[${productIndex}][${colIndex}]`] = undefined;
            }
          });
          if (Object.keys(fieldsToClear).length > 0) {
            setTimeout(() => {
              form.setFieldsValue(fieldsToClear);
            }, 0);
          }
        }

        return [...filteredSelected, { ...value, fieldIndex: productIndex }];
      }

      return filteredSelected;
    });
  };

  const handleRemoveRow = productIndex => {
    const subscriptionAddOn = getFieldValue('sub-add-on-product');

    // Modify values
    const updatedSubscriptionAddOn = subscriptionAddOn.map(col => col.filter((_, i) => i !== productIndex));

    form.setFieldsValue({
      'sub-add-on-product': updatedSubscriptionAddOn
    });

    // Update rows and selected products state
    setRow(prevRow => prevRow.filter((_, index) => _ !== productIndex));
    setSubAddonSelectedProducts(prevSelected => prevSelected.filter(item => item.fieldIndex !== productIndex));
  };

  //if inside some is true means it is a selectedProduct, and it will become false overall due to !, thus the selectedProducts is not chosen in selections
  //labelInValue = key and label pair
  //thus all data passed in must be key and label pair ?
  const renderProductRow = productIndex => {
    // Step 1: Get the selected add-on product for this row and find its name
    const selectedEntry = subAddOnSelectedProducts.find(sp => sp.fieldIndex === productIndex);
    const selectedProduct = selectedEntry ? productData.find(p => p._id === selectedEntry.key) : null;
    const selectedProductName = selectedProduct ? selectedProduct.name : null;

    // Step 2: Match the add-on product's name against billingFunctions labels to get its function value
    // e.g. product named "Subscription Add On" → normalize → match "subscriptionaddon" → value: "subscriptionAddOn"
    let addOnFunctionValue = null;
    if (selectedProductName) {
      const normalizedProductName = selectedProductName.toLowerCase().replace(/\s+/g, '');
      const matched = billingFunctions.find(bf => normalizedProductName.includes(bf.label.toLowerCase().replace(/\s+/g, '')));
      addOnFunctionValue = matched ? matched.value : null;
    }

    return (
      <Row key={productIndex} style={{ width: '100%', display: 'flex', marginLeft: 0, marginRight: 0 }}>
        <Col style={{ width: colWidth, minWidth: minColWidth, flex: '1 1 auto', borderLeft: '1px solid #ccc' }} className={styles.pricingGridItem}>
          <Form.Item style={{ width: '90%', textAlign: 'center', marginBottom: '0px' }}>
            {getFieldDecorator(`sub-add-on-product[${productIndex}][${0}]`, {
              rules: [{ required: true, message: 'Please select a product' }]
            })(
              <Select
                placeholder="Select a product"
                style={{ width: '100%' }}
                onChange={value => handleProductSelection(value, productIndex)}
                labelInValue
              >
                {productData
                  .filter(
                    product =>
                      !subAddOnSelectedProducts.some(sp => sp.key === product._id && sp.fieldIndex !== productIndex) &&
                      product.categoryParent.includes('subscriptionAddOn')
                  )
                  .map(product => (
                    <Select.Option key={product._id} value={product._id}>
                      {product.name}
                    </Select.Option>
                  ))}
              </Select>
            )}
          </Form.Item>
          <div style={{ position: 'absolute', top: '5px', right: '5px' }}>
            {productIndex !== 0 ? (
              <Button type="danger" size="small" style={{ height: '20px' }} onClick={() => handleRemoveRow(productIndex)}>
                -
              </Button>
            ) : null}
          </div>
        </Col>
        {column.map((row, rowIndex) => {
          const disabled = false; // !isColumnDisabled(rowIndex);
          return (
            <Col
              key={`pricing-${productIndex}-${rowIndex}`}
              style={{
                width: colWidth,
                minWidth: minColWidth,
                flex: '1 1 auto',
                backgroundColor: disabled ? '#f5f5f5' : undefined
              }}
              className={styles.pricingGridItem}
            >
              {pricing(rowIndex, productIndex, disabled)}
            </Col>
          );
        })}
      </Row>
    );
  };

  const getProductNameById = productId => {
    const product = productData.find(p => p._id === productId);
    return product ? product.name : 'Unknown Product';
  };

  const renderPackageRow = () => {
    return (
      <>
        {column.map((col, colIndex) => {
          const productName = packageNames[colIndex] || 'Select Package';

          return (
            <Col
              key={`package-${colIndex}`}
              style={{ width: colWidth, minWidth: minColWidth, flex: '1 1 auto' }}
              className={styles.pricingGridHeader}
            >
              {productName}
            </Col>
          );
        })}
      </>
    );
  };

  // Show message if no products are selected in PricingTableModal
  if (!currentSubscriptionProducts || currentSubscriptionProducts.length === 0) {
    return <Alert message="Please select a product in the Pricing Table first" type="info" showIcon style={{ marginTop: '8px' }} />;
  }

  return (
    <div className={styles.pricingGridContainer}>
      <Row className={styles.pricingGridRow} style={{ width: '100%', display: 'flex', marginLeft: 0, marginRight: 0 }}>
        <Col
          style={{ width: colWidth, minWidth: minColWidth, flex: '1 1 auto', padding: '0', borderLeft: '1px solid #ccc' }}
          className={styles.pricingGridHeader}
        >
          <div className={styles.diagonalHeader}>
            <span className={styles.productLabel}>Add-Ons</span>
            <span className={styles.unitLabel}>Package</span>
          </div>
        </Col>
        {renderPackageRow()}
      </Row>
      {row.map(index => renderProductRow(index))}
      <Row style={{ width: '100%', display: 'flex', marginLeft: 0, marginRight: 0 }}>
        <Col style={{ width: colWidth, minWidth: minColWidth, flex: '1 1 auto', borderLeft: '1px solid #ccc' }} className={styles.pricingGridItem}>
          <Button onClick={addProduct} type="dashed" style={{ width: '90%' }}>
            <Icon type="plus" /> Add Sub Add-Ons
          </Button>
        </Col>
        {/* ✅ Dynamically render empty columns based on column state */}
        {column.map((_, colIndex) => (
          <Col
            key={`empty-${colIndex}`}
            style={{ width: colWidth, minWidth: minColWidth, flex: '1 1 auto' }}
            className={styles.pricingGridItem}
          ></Col>
        ))}
      </Row>
    </div>
  );
};

export default Form.create()(SubscriptionAddOnPricingTable);
